import React, { useEffect, useState } from 'react'
import { getImages } from './const'
import { Link } from 'react-router-dom'

const Footer = () => {
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            <section className='footer-wrap'>
                <div className='container'>
                    <div className='footer-top mb-md-5 mb-0'>
                        <div className='row'>
                            <div className='col-xl-4 col-lg-4 col-md-5 col-12 mb-md-0 mb-5'>
                                <Link to='/' className='footer-logo'>
                                    <img src={getImages('eec-logo.png')} alt='eec' />
                                </Link>
                            </div>
                            <div className='col-lg-3 col-md-4 mb-md-0 mb-4 ps-md-0 ps-5'>
                                <div className='d-md-block d-flex align-items-center justify-content-between'>
                                    <div className='fot-sm-title'>Tampa, FL</div>
                                    <div className='fot-xxs-title d-none d-md-block'>7817 N Dale Mabry Hwy <br />Tampa, FL 33614</div>
                                    <div><Link className='fot-xs-title' to="tel:8135927722">(813) 592-7722</Link></div>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-3 mb-md-0 mb-4 ps-md-0 ps-5'>
                                <div className='d-md-block d-flex align-items-center justify-content-between'>
                                    <div className='fot-sm-title'>San Clemente, CA</div>
                                    <div className='fot-xxs-title d-none d-md-block'>101 W Avenida Vista Hermosa Ste 464 <br />San Clemente , CA 92672</div>
                                    <div><Link className='fot-xs-title' to="tel:9492731100">(949) 273-1100</Link></div>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-3 mb-md-0 mb-2 ps-md-0 ps-md-5 text-md-end text-center'>
                                <ul className='social-icons d-inline-flex d-md-inline-block text-start'>
                                    <li>
                                        <a href='https://www.facebook.com/euroec' target='_blank'><span className='social-icon'><img src={getImages('facebook-icon.png')} /></span> <span className='d-none d-md-inline-block'>Facebook</span></a>
                                    </li>
                                    {/* <li>
                                        <a href='#'><span className='social-icon'><img src={getImages('ico-twitter.svg')}/></span> <span className='d-none d-md-inline-block'>Twtiter</span></a>
                                    </li> */}
                                    <li>
                                        <a href='https://www.instagram.com/europeanexoticcenter/' target='_blank'><span className='social-icon'><img src={getImages('instagram-icon.png')} /></span> <span className='d-none d-md-inline-block'>Instagram</span></a>
                                    </li>
                                    <li>
                                        <a href='https://www.youtube.com/channel/UCsLgQ1XxLP5_3G2Fc6duF0Q' target='_blank'><span className='social-icon'><img src={getImages('youtube-icon.png')} /></span> <span className='d-none d-md-inline-block'>Youtube</span></a>
                                    </li>
                                    <li>
                                        <a href='/sitemap'><span className='social-icon'>&nbsp;</span> <span>Sitemap</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='footer-bottom'>
                        <div className='d-md-flex align-items-center justify-content-between'>
                            <div className='order-md-2 powered-by text-md-end mb-md-0 mb-3'>
                                {isMobile ? 
                                    <a href='https://greenlightautomotivesolutions.com/custom-software.php ' target='_blank'><img src={getImages('gas-horz.svg')}/></a>
                                    :
                                    <a href='https://greenlightautomotivesolutions.com/custom-software.php ' target='_blank'><img src={getImages('gas-vert.svg')}/></a>
                                }
                            </div>
                            <div className='copyright'>Copyright &copy; European Exotic Center</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Footer